// Dalga 6a (kurucu, 26 Eylül): golf6App.nl.ts'nin Türkçesi. Apple ve Google düğmeleri Türkçe bir
// cihazda göründüğü gibi yazıldı ("Ana Ekrana Ekle", "Ekle", "Uygulamayı yükle"). Ton: sıcak
// sen-dili; {naam}'dan sonra ek yok.
export const appGolf6Tr = {
    tabletGuide: {
        title: 'iPad panoya nasıl bağlanır',
        intro: 'Üç adım, yaklaşık bir dakika. Bu sayfayı açık tut.',
        step1Title: 'iPad’de Safari’yi aç',
        step1Body: 'Adres çubuğuna şu adresi yaz:',
        copy: 'Kopyala',
        copied: 'Kopyalandı',
        copyLabel: 'Adresi kopyala: {url}',
        step2Title: 'Pano bir kod gösterir',
        step2Body: 'ABCD-2345 gibi sekiz karakter. iPad’i öyle bırak.',
        step3Title: 'Kodu buraya yaz',
        step3Body: 'Panonun asılı olduğu odayı da seç. Pano birkaç saniye içinde görünür.',
        enterCode: 'Kodu gir',
        orTitle: 'Yazmak istemiyor musun?',
        orBody: 'Bir QR kodu oluştur ve iPad’in kamerasıyla tara. Pano kendini bağlar.',
        qrButton: 'QR koduyla bağla',
        tipsTitle: 'Duvardaki pano için ipuçları',
        tips: [
            {
                title: 'Panoyu ana ekrana ekle',
                body: 'Böylece pano adres çubuğu olmadan tam ekran açılır. Bunu bağlamadan önce yap: ana ekrandaki uygulamanın kendi hafızası vardır ve ayrıca bağlanır.',
            },
            {
                title: 'Otomatik Kilit: Hiçbir Zaman',
                body: 'Ayarlar › Ekran ve Parlaklık › Otomatik Kilit › Hiçbir Zaman. iPad’i şarjda bırak, ekran açık kalır.',
            },
            {
                title: 'Rehberli Erişim',
                body: 'Ayarlar › Erişilebilirlik › Rehberli Erişim (iOS 12’li eski iPad: Ayarlar › Genel › Erişilebilirlik › Rehberli Erişim): aç ve bir kod seç. Panoyu aç ve Ana Ekran düğmesine (ya da üst düğmeye) hızlıca üç kez bas. Böylece çocuklar panoda kalır.',
            },
            {
                title: 'Ses için bir kez dokun',
                body: 'iPad ancak bir dokunuştan sonra ses çalar. Açıldıktan sonra panoya bir kez dokun, ezanı ve çağrıları duyarsın.',
            },
        ],
        homeScreenHow: 'Ana ekrana nasıl eklerim?',
    },
    qr: {
        title: 'QR koduyla bağla',
        intro: 'iPad kodu kamerasıyla tarar ve kendini bağlar. Hiçbir şey yazman gerekmez.',
        room: 'Oda',
        name: 'Tabletin adı',
        defaultName: 'iPad {room}',
        create: 'QR kodu oluştur',
        scanTitle: 'iPad’in kamerasıyla tara',
        scanSteps: [
            'iPad’de Kamera uygulamasını aç.',
            'Üstte bir bildirim çıkana kadar bu koda doğrult.',
            'Bildirime dokun. Pano Safari’de açılır ve kendini bağlar.',
        ],
        validFor: '{time} daha geçerli · bir kez çalışır',
        qrLabel: 'Tableti bağlamak için QR kodu, oda: {room}',
        waiting: 'iPad’in taramasını bekliyor…',
        claimed: 'Bağlandı: {name}',
        claimedBody: 'Pano ({room}) artık takvimi gösteriyor.',
        expired: 'Bu QR kodunun süresi doldu',
        expiredBody: 'Bir QR kodu 10 dakika ve yalnızca bir kez çalışır. Yenisini oluştur.',
        again: 'Yeni QR kodu',
        done: 'Tamam',
        safariNote: 'QR kodu panoyu Safari’de açar. Pano zaten ana ekranda mı? O zaman o uygulamayı kodla bağla.',
        keepPrivate: 'Bu kodu başkalarına gösterme: kim tararsa ailenin panosunu alır.',
    },
    phoneQr: {
        title: 'AMUMIN’i telefonunda aç',
        body: 'Bu kodu telefonunun kamerasıyla tara. Sonra AMUMIN’i ana ekranına ekle.',
        label: 'QR kodu: {url}',
    },
    install: {
        platform: 'Hangi cihaz?',
        ios: 'iPhone/iPad',
        android: 'Android',
        desktop: 'Bilgisayar',
        thisDevice: '{platform} (bu cihaz)',
        iosSteps: [
            '{url} adresini Safari’de aç.',
            'Paylaş’a dokun: yukarı oklu küçük kare. iPhone’da altta, iPad’de üstte adresin yanında. Göremiyor musun? Önce ··· simgesine dokun.',
            'Paylaşım menüsünde Ana Ekrana Ekle’yi görene kadar kaydır ve ona dokun. Eski bir iPad’de alt sıradadır: o sırayı sola kaydır.',
            'Sağ üstte Ekle’ye dokun.',
            'Bundan sonra {app} uygulamasını ana ekrandaki simgeyle aç.',
        ],
        androidSteps: [
            '{url} adresini Chrome’da aç.',
            'Sağ üstteki üç noktaya dokun.',
            'Uygulamayı yükle’yi (ya da Ana ekrana ekle’yi) seç.',
            'Yükle’ye dokun. {app} artık uygulamaların arasında.',
        ],
        desktopSteps: [
            '{url} adresini Chrome’da ya da Edge’de aç.',
            'Adres çubuğunun sağındaki yükleme simgesine tıkla (oklu küçük bir ekran).',
            'Yükle’ye tıkla. {app} bundan sonra kendi penceresinde açılır.',
        ],
        ui: {
            share: 'Paylaş',
            addToHome: 'Ana Ekrana Ekle',
            add: 'Ekle',
            cancel: 'Vazgeç',
            installApp: 'Uygulamayı yükle',
            install: 'Yükle',
        },
        pictureLabel: '{n}. adım için örnek',
    },
    stepUp: {
        which: 'Kendi AMUMIN şifreni yaz: {host} adresinde giriş yaptığın şifre.',
        notThese: 'Yani Wi-Fi şifresi değil, iPad’in kodu da değil.',
        why: 'Bunu tablet bağlamak gibi önemli adımlarda soruyoruz. Sonra 10 dakika boyunca tekrar sormayız.',
        account: 'Hesabın',
        password: 'AMUMIN şifren',
        forgot: 'Şifreni mi unuttun?',
    },
    tasks: {
        forWho: 'Kimin için?',
        forWhoHint: 'Çocuklar zaten seçili. Birini eklemek ya da çıkarmak için bir isme dokun.',
        nobody: 'En az bir kişi seç.',
    },
    werklijstDoc: {
        read: 'Tavsiyeyi oku',
        readLabel: 'Tavsiyeyi oku: {title}',
        loading: 'Tavsiye yükleniyor…',
        missing: 'Bu tavsiye uygulamanın bu sürümünde henüz yok.',
        error: 'Tavsiye şu an okunamıyor. Biraz sonra tekrar dene.',
        back: 'Geri',
        external: '(yeni pencerede açılır)',
    },
};
//# sourceMappingURL=golf6App.tr.js.map